// extracted by mini-css-extract-plugin
export var checkbox = "_7f-0";
export var circle = "_7f-3";
export var horizontalContainer = "_7f-7";
export var sm = "_7f-5";
export var switch0 = "_7f-2";
export var switchDisabled = "_7f-8";
export var switchEnabled = "_7f-1";
export var textSwitchContainer = "_7f-9";
export var textSwitchOption = "_7f-a";
export var textSwitchOptionSelected = "_7f-b";
export var verticalContainer = "_7f-6";
export var xs = "_7f-4";